// extracted by mini-css-extract-plugin
export var parcelRow = "_uc-0";